export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS"
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS"
export const GET_NOTIFICATIONS_FAILED = "GET_NOTIFICATIONS_FAILED"

export const GET_CUSTOM_EMAILS = "GET_CUSTOM_EMAILS"
export const GET_CUSTOM_EMAILS_SUCCESS = "GET_CUSTOM_EMAILS_SUCCESS"
export const GET_CUSTOM_EMAILS_FAILED = "GET_CUSTOM_EMAILS_FAILED"

export const GET_WEB_ALERTS = "GET_WEB_ALERTS"
export const GET_WEB_ALERTS_SUCCESS = "GET_WEB_ALERTS_SUCCESS"
export const GET_WEB_ALERTS_FAILED = "GET_WEB_ALERTS_FAILED"

export const GET_EVENTS_BY_SEARCH = "GET_EVENTS_BY_SEARCH"
export const GET_EVENTS_BY_SEARCH_SUCCESS = "GET_EVENTS_BY_SEARCH_SUCCESS"
export const GET_EVENTS_BY_SEARCH_FAILED = "GET_EVENTS_BY_SEARCH_FAILED"

export const ADD_COMMUNICATION = "ADD_COMMUNICATION"
export const ADD_COMMUNICATION_SUCCESS = "ADD_COMMUNICATION_SUCCESS"
export const ADD_COMMUNICATION_FAILED = "ADD_COMMUNICATION_FAILED"

export const OPEN_DELETE_COMMUNICATION_MODAL = "OPEN_DELETE_COMMUNICATION_MODAL"
export const HIDE_DELETE_COMMUNICATION_MODAL = "HIDE_DELETE_COMMUNICATION_MODAL"

export const DELETE_COMMUNICATION = "DELETE_COMMUNICATION"
export const DELETE_COMMUNICATION_SUCCESS = "DELETE_COMMUNICATION_SUCCESS"
export const DELETE_COMMUNICATION_FAILED = "DELETE_COMMUNICATION_FAILED"

export const GET_COMMUNICATION = "GET_COMMUNICATION"
export const GET_COMMUNICATION_SUCCESS = "GET_COMMUNICATION_SUCCESS"
export const GET_COMMUNICATION_FAILED = "GET_COMMUNICATION_FAILED"
export const RESET_COMMUNICATION = "RESET_COMMUNICATION"

export const UPDATE_COMMUNICATION = "UPDATE_COMMUNICATION"
export const UPDATE_COMMUNICATION_SUCCESS = "UPDATE_COMMUNICATION_SUCCESS"
export const UPDATE_COMMUNICATION_FAILED = "UPDATE_COMMUNICATION_FAILED"

export const OPEN_SEND_COMMUNICATION_MODAL = "OPEN_SEND_COMMUNICATION_MODAL"
export const HIDE_SEND_COMMUNICATION_MODAL = "HIDE_SEND_COMMUNICATION_MODAL"

export const SEND_COMMUNICATION = "SEND_COMMUNICATION"
export const SEND_COMMUNICATION_SUCCESS = "SEND_COMMUNICATION_SUCCESS"
export const SEND_COMMUNICATION_FAILED = "SEND_COMMUNICATION_FAILED"

export const OPEN_SEND_WEB_ALERT_MODAL = "OPEN_SEND_WEB_ALERT_MODAL"
export const HIDE_SEND_WEB_ALERT_MODAL = "HIDE_SEND_WEB_ALERT_MODAL"

export const SEND_WEB_ALERT = "SEND_WEB_ALERT"
export const SEND_WEB_ALERT_SUCCESS = "SEND_WEB_ALERT_SUCCESS"
export const SEND_WEB_ALERT_FAILED = "SEND_WEB_ALERT_FAILED"

export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAILED = "GET_USERS_FAILED"
export const RESET_USERS_LIST = "RESET_USERS_LIST"
